export const companies = [
  { companyId: 4, label: 'EVO SOLUÇÕES. - Empresa Teste' },
  { companyId: 120, label: 'BP TRUCK', cnpj: '13.762.231/0001-84' },
  { companyId: 123, label: 'BP STIP', cnpj: '55.049.268/0001-00' },
  { companyId: 125, label: 'BP TRUCK LTDA', cnpj: '55.424.073/0001-00' },
  { companyId: 128, label: 'BP SEGURADORA', cnpj: '50.180.527/0001-13' },
];

export const companiesDev = [
  { companyId: 118, label: 'Bem Protege Dev', cnpj: '50.670.438/0001-55' },
  { companyId: 119, label: 'Bem Protege QA', cnpj: '88.196.443/0001-40' }
]; 
